import { render, staticRenderFns } from "./AthleteReportsSummary.vue?vue&type=template&id=4329ce2c&"
import script from "./AthleteReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteReportsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports